import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { api, clearAuth, updateStoredUser } from "../api/client";

const inputCls = "w-full border border-gray-200 rounded-xl px-3 py-2.5 text-sm focus:border-[#10a37f] focus:ring-2 focus:ring-[#10a37f]/10 outline-none transition-all bg-white disabled:bg-gray-50 disabled:text-gray-400";

function Field({ label, children }) {
  return (
    <div>
      <label className="block text-xs font-semibold text-gray-500 mb-1.5 uppercase tracking-wide">{label}</label>
      {children}
    </div>
  );
}

export default function ProfileView() {
  const { user, setUser } = useOutletContext();
  const [form, setForm] = useState({
    full_name: user?.full_name || "",
    phone: user?.phone || "",
    password: "",
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [error, setError] = useState("");

  async function submit(e) {
    e.preventDefault();
    setStatus("");
    setError("");
    setLoading(true);
    try {
      const payload = {
        full_name: form.full_name,
        phone: form.phone || null,
        ...(form.password ? { password: form.password } : {}),
      };
      const result = await api.updateMyProfile(payload);
      if (result.password_changed) {
        clearAuth();
        setUser(null);
        return;
      }
      const profile = await api.me();
      updateStoredUser(profile);
      setUser(profile);
      setForm((current) => ({ ...current, password: "" }));
      setStatus("Profil berhasil diupdate.");
    } catch (err) {
      setError(err.message || "Gagal update profil");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="flex-1 min-h-0 overflow-y-auto bg-gray-50">
      <header className="sticky top-0 z-40 bg-white border-b border-gray-100 shadow-sm">
        <div className="flex items-center h-16 pl-14 pr-4 lg:px-6 gap-3">
          <div className="w-8 h-8 rounded-lg bg-gray-900 flex items-center justify-center">
            <span className="material-symbols-outlined text-white text-[18px]">account_circle</span>
          </div>
          <div>
            <h1 className="font-bold text-gray-900 text-base md:text-lg leading-tight">Profil Saya</h1>
            <p className="text-xs text-gray-400 hidden sm:block">Edit data pribadi dan password akun</p>
          </div>
        </div>
      </header>

      <div className="p-4 md:p-6 max-w-2xl">
        <form onSubmit={submit} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-5 space-y-4">
          {status && <div className="bg-green-50 border border-green-200 text-green-700 rounded-xl p-3 text-sm">{status}</div>}
          {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-xl p-3 text-sm">{error}</div>}

          <Field label="Nama Lengkap">
            <input className={inputCls} value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} required />
          </Field>
          <Field label="Email">
            <input className={inputCls} value={user?.email || ""} disabled />
          </Field>
          <Field label="No. Telepon">
            <input className={inputCls} value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Opsional" />
          </Field>
          <Field label="Password Baru">
            <input className={inputCls} type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Kosongkan jika tidak diganti" minLength={6} />
            <p className="mt-2 text-xs text-gray-400">Kalau password diganti, kamu akan diminta login ulang.</p>
          </Field>

          <div className="flex justify-end pt-2 border-t border-gray-100">
            <button type="submit" disabled={loading} className="px-4 py-2.5 rounded-xl bg-[#202123] hover:bg-[#10a37f] text-white text-sm font-semibold transition-colors disabled:opacity-50">
              {loading ? "Menyimpan..." : "Simpan Profil"}
            </button>
          </div>
        </form>
      </div>
    </main>
  );
}
